var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
const claim = namespace('claim');
const qualification = namespace('qualification');
let IsAwareOfPublicWorksQuestion = class IsAwareOfPublicWorksQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.yesNoQuestionValuesAndTradKeys = YES_OR_NO_CHOICES;
    }
    updateQualification(isAwareOfPublicWorks) {
        this.updateAndSaveQualification({
            qualificationPayload: { isAwareOfPublicWorks },
            step: this.step,
        });
    }
    get answer() {
        if (this.electricalDamageQualification.isAwareOfPublicWorks === null) {
            return null;
        }
        return this.electricalDamageQualification.isAwareOfPublicWorks
            ? this.$tc('claim.qualification.electrical.is_aware_of_public_works.sumup.yes')
            : this.$tc('claim.qualification.electrical.is_aware_of_public_works.sumup.no');
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], IsAwareOfPublicWorksQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    qualification.State('qualification')
], IsAwareOfPublicWorksQuestion.prototype, "electricalDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], IsAwareOfPublicWorksQuestion.prototype, "updateAndSaveQualification", void 0);
IsAwareOfPublicWorksQuestion = __decorate([
    Component({
        components: { RadioPrimaryButton, QuestionPanel },
        props: QuestionProps,
    })
], IsAwareOfPublicWorksQuestion);
export default IsAwareOfPublicWorksQuestion;
